import { io } from "socket.io-client";

export const Socket = io("https://app.f-engelservice.com:5000", {
    autoConnect: false,
});
